var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.586 7.293"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.172 5.879L6.293 1 1.414 5.879",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi41ODYiIGhlaWdodD0iNy4yOTMiIHZpZXdCb3g9IjAgMCAxMi41ODYgNy4yOTMiPg0KICA8cGF0aCBpZD0iY2hldnJvbl9hcnJvdyIgZD0iTTYsOWw0Ljg3OSw0Ljg3OUwxNS43NTgsOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcuMTcyIDE0Ljg3OSkgcm90YXRlKDE4MCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz4NCjwvc3ZnPg0K";
export { SvgChevron as ReactComponent };